const backdropOpacity = {
    name: "backdrop-opacity",
    path: "/backdrop-opacity",
    title: "backdrop-opacity",
    description: "Utilities for applying backdrop-opacity filter effects to element's backdrop:",
    value: {
        'backdrop-filter': {
            'backdrop-opacity-<number>': 'opacity(<number>%)'
        },
    },
    exampleData: [
        {
            "title": "backdrop-opacity-50, backdrop-opacity-100",
            "description": "to control an element's backdrop-opacity:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-3 gap-10 !bg-none !border-0 pt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg backdrop-invert backdrop-opacity-0",
                        "text": "backdrop-opacity-0",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg backdrop-invert backdrop-opacity-25",
                        "text": "backdrop-opacity-25",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg backdrop-invert backdrop-opacity-95",
                        "text": "backdrop-opacity-95",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<img class="backdrop-opacity-0" src="/img/mountains.jpg" />
<img class="backdrop-opacity-25" src="/img/mountains.jpg" />
<img class="backdrop-opacity" src="/img/mountains.jpg" />`
            }
        }
    ]
};

export default backdropOpacity;